/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Backup policy type. `UNSPECIFIED` is supported only in responses. 
*/
export enum BackupPolicyType {
  BACKUP_POLICY_TYPE_UNSPECIFIED = 'UNSPECIFIED',
  BACKUP_POLICY_TYPE_STANDARD = 'STANDARD',
  BACKUP_POLICY_TYPE_NATIVE_STANDARD = 'NATIVE_STANDARD',
  BACKUP_POLICY_TYPE_HIGH_FREQUENCY = 'HIGH_FREQUENCY',
  BACKUP_POLICY_TYPE_PITR = 'PITR',
  BACKUP_POLICY_TYPE_AWS_NATIVE_PITR = 'AWS_NATIVE_PITR'
}
